import { TransactionStatus, TransactionStatusType } from '@/api/store-orders-types'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { useEffect, useRef, useState } from 'react'

interface VerifoneCheckoutProps {
	title: string
	isOpen: boolean
	onClose: () => void
	transactionStatus?: TransactionStatusType
	verifoneData: { checkoutId: string; checkoutUrl?: string }
}

export function VerifoneCheckoutComponent({ title, isOpen, onClose, verifoneData }: VerifoneCheckoutProps) {
	const [checkoutContainerRef, setCheckoutContainerRef] = useState<HTMLDivElement | null>(null)

	const checkoutInitialized = useRef(false)
	const [checkoutData, setCheckoutData] = useState<{ checkoutId: string; checkoutUrl: string } | null>(null)

	const elementIds = {
		checkoutContainer: 'verifone-checkout-container',
		checkoutScript: 'verifone-checkout-script'
	}

	useEffect(() => {
		if (!verifoneData || !verifoneData.checkoutUrl || !verifoneData.checkoutId || !checkoutContainerRef) {
			return
		}

		setCheckoutData({
			checkoutId: verifoneData.checkoutId,
			checkoutUrl: verifoneData.checkoutUrl
		})
	}, [verifoneData, checkoutContainerRef])

	useEffect(() => {
		if (checkoutInitialized.current || !checkoutData || !checkoutContainerRef) {
			return
		}
		checkoutInitialized.current = true

		const script = document.createElement('script')
		script.id = elementIds.checkoutScript
		script.src = checkoutData.checkoutUrl
		script.defer = true
		checkoutContainerRef.appendChild(script)
	}, [checkoutData])

	const handleClose = () => {
		const scriptElement = document.getElementById(elementIds.checkoutScript)
		scriptElement?.parentNode?.removeChild(scriptElement)
		checkoutInitialized.current = false
		onClose()
	}

	return (
		<Dialog open={isOpen} onOpenChange={handleClose}>
			<DialogContent className='max-w-lg'>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
				</DialogHeader>
				<div className='min-h-[500px]'>
					<div ref={el => setCheckoutContainerRef(el)} className={elementIds.checkoutContainer} />
				</div>
			</DialogContent>
		</Dialog>
	)
}
